import { render, staticRenderFns } from "./EmailAttachmentItem.vue?vue&type=template&id=5a2329fe&scoped=true"
import script from "./EmailAttachmentItem.vue?vue&type=script&lang=js"
export * from "./EmailAttachmentItem.vue?vue&type=script&lang=js"
import style0 from "./EmailAttachmentItem.vue?vue&type=style&index=0&id=5a2329fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a2329fe",
  null
  
)

export default component.exports